
  export default {
    name: `AboutUs`,
    computed: {
      websiteUrl() {
        return this.$config.public.websiteUrl
      },
    },
  }
